import './AccessLoadingSpinner.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { Skeleton, Table } from 'antd';
export const AccessLoadingSpinner = ({ loading, sorting }) => React.createElement(LoadingSpinner, { className: 'access-spinner', spinning: loading || sorting, tip: loading ?
        COPY_SPECIFIC.GETTING_DATA_FROM_SALESFORCE :
        COPY_SPECIFIC.CRUNCHING_THE_NUMBERS }, React.createElement(Table, { columns: [...Array(4)].map((_, index) => ({
        render: function render() {
            return (React.createElement(Skeleton, { active: true, 
                // eslint-disable-next-line react/no-array-index-key
                key: index, paragraph: false }));
        }
    })), dataSource: [...Array(5)].map((_, index) => ({
        key: `key${index}`
    })), pagination: false, rowKey: 'key' }));
